import { createTheme } from '@mui/material/styles';
import '@fontsource/playfair-display'

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF0099',
      light: '#FF66CC',
      dark: '#CC0077',
    },
    secondary: {
      main: '#1a1a1a',
    },
    background: {
      default: '#fff',
      paper: '#fff',
    },
    text: {
      primary: '#1a1a1a',
      secondary: '#666',
    },
  },
  typography: {
    fontFamily: '"Playfair Display", "Georgia", serif',
    h1: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 700,
    },
    h3: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
    },
    body1: {
      fontFamily: '"nunito", "Helvetica Neue", sans-serif',
    },
    body2: {
      fontFamily: '"nunito", "Helvetica Neue", sans-serif',
    },
    button: {
      fontFamily: '"nunito", sans-serif',
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '25px',
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff0f7',
        },
      },
    },
  },
});

export default theme;